$(function(){

//初期設定
var $num = 1;  //質問の順番
var $totalQ = 21;  //質問数
var $nextQ = 'q' + $num;  //表示させるdiv（ID）の指定
var $parentDiv = $('#diagnosis');
var sum = function(arr) { //配列合計関数
var total = 0, i = 0, len = 0;
	if (Object.prototype.toString.call(arr) !== '[object Array]') return;
	for (i = 0, len = arr.length; i < len; i++) total += arr[i];
	return total;
};

//問題別点数配列
var answerArray = [
	[0,0,0], //Aグループ(name="0_?")集計
	[0,0,0], //Bグループ(name="1_?")集計
	[0,0,0], //Cグループ(name="2_?")集計
	[0,0,0], //Dグループ(name="3_?")集計
	[0,0,0], //Eグループ(name="4_?")集計
	[0,0,0], //Fグループ(name="5_?")集計
	[0,0,0], //Gグループ(name="6_?")集計	
];
//グループ別点数配列
var totalArray = [
	{priority:'A',score:0},
	{priority:'B',score:0},
	{priority:'C',score:0},
	{priority:'D',score:0},
	{priority:'E',score:0},
	{priority:'F',score:0},
	{priority:'G',score:0},
];

//プログレスバー
var Progress = (function () {
	function Progress (p) {
		this.bar = document.querySelectorAll('.progress-bar')[0];
		this.p = p;
		this.update();
	};
	Progress.prototype.update = function(){
		this.bar.style.width = this.p + '%';
	};
	Progress.prototype.countup = function () {
		if (this.p < 100) { this.p += (100/$totalQ); }
		this.update();
	};
	Progress.prototype.countdown = function () {
		if (0 < this.p) { this.p -= (100/$totalQ); };
		this.update();
	};
	return Progress;
}());
var pro = new Progress(0);

//該当問題算出
function Question(){}
Question.prototype.next = function(){
	var $num = $parentDiv.attr('data-current').replace(/[^0-9^\.]/g,'');
	$num ++;
	$nextQ = 'q' + $num;
	$parentDiv.attr('data-current',$nextQ);
	pro.countup();//プログレスバー反映
};
Question.prototype.back = function(){
	var $num = $parentDiv.attr('data-current').replace(/[^0-9^\.]/g,'');
	$num --;
	$nextQ = 'q' + $num;
	$parentDiv.attr('data-current',$nextQ);
	pro.countdown();
	$('.progress-bar p').html($num + '問目 / 21問中');
};
var question = new Question();

//診断結果表示
function result(){
	$("#diagnosis").addClass("end"); //結果表示のみレイアウトの高さ(SP)を変える
	//各グループの合計点数格納
	totalArray[0]['score'] = sum(answerArray[0]); //Aグループのトータル
	totalArray[1]['score'] = sum(answerArray[1]); //Bグループのトータル
	totalArray[2]['score'] = sum(answerArray[2]); //Cグループのトータル
	totalArray[3]['score'] = sum(answerArray[3]); //Dグループのトータル
	totalArray[4]['score'] = sum(answerArray[4]); //Eグループのトータル
	totalArray[5]['score'] = sum(answerArray[5]); //Fグループのトータル
	totalArray[6]['score'] = sum(answerArray[6]); //Gグループのトータル
	totalArray.sort(
		function(a,b){		
			if( a.score < b.score ) return 1; //スコア降順
			if( a.score > b.score ) return -1;
			if( a.priority < b.priority ) return -1;//グループ名(優先順位)昇順
			if( a.priority > b.priority ) return 1;
			return 0;
		}
	);
	
	var $high = totalArray[0]['priority']; //最高値を取得
	switch($high){
		case 'A' : $('#choiceA').addClass('high'); break;
		case 'B' : $('#choiceB').addClass('high'); break;
		case 'C' : $('#choiceC').addClass('high'); break;
		case 'D' : $('#choiceD').addClass('high'); break;
		case 'E' : $('#choiceE').addClass('high'); break;
		case 'F' : $('#choiceF').addClass('high'); break;
		case 'G' : $('#choiceG').addClass('high'); break;
	}
	
	//重複を削除(scoreが等しいものを削除)
		//確認用console.log(totalArray);
	// IE11のため改編（Babel + polyfill 未使用）
	function filterUniqueItemsById (array) {
	  const itemIds = array.map(function(item) {
	    return item.score;
	  });
	  return array.filter(function(item, index) {
	    return itemIds.indexOf(item.score) === index;
	  });
	}
	
	const result = filterUniqueItemsById(totalArray);
	
		//確認用console.log(result);
		//確認用console.log(JSON.stringify(result, null, 2)); 
	var $low = result[result.length - 1]['priority']; //最低値を取得
	if(result.length == 1 ) { //すべてのscoreが等しい場合はBを下段に出力する。
		var $low = 'B';
	}
	//確認用console.log($low);
	switch($low){
		case 'A' : $('#choiceA').addClass('low'); break;
		case 'B' : $('#choiceB').addClass('low'); break;
		case 'C' : $('#choiceC').addClass('low'); break;
		case 'D' : $('#choiceD').addClass('low'); break;
		case 'E' : $('#choiceE').addClass('low'); break;
		case 'F' : $('#choiceF').addClass('low'); break;
		case 'G' : $('#choiceG').addClass('low'); break;
	}
	//lowを最後尾に移動
	$('.resultBox.low').appendTo($('#result'));
}

//質問順番をランダムに並び替え
var questionHtmlArr = [];
$('#diagnosis .question').each(function() {
  questionHtmlArr.push($(this).html());
});
questionHtmlArr.sort(function() {
	return Math.random() - Math.random();
});
$("#diagnosis .question").remove();
for(var i = 0; i < questionHtmlArr.length; i++) {
	var id_num = i+1;
	$("#diagnosis #result").before('<div class="question" id="q'+id_num+'">'+questionHtmlArr[i]+'</div>');
}

//スタートボタン押下
$('button[name="start"]').on('click',function() {
	$('#diagnosis').addClass('question_start');
	$('#start').delay(100).fadeOut('fast'); //終了した問題を消す
	$('#q1').fadeIn('fast'); //次の問題を表示

	//テストツール
	var firstQttl = $('#q1 input[type="radio"]').first().attr('name').split('_');
	if(Number(firstQttl[0]) == 0) {
		var $qName = "面談準備";
	} else if(Number(firstQttl[0]) == 1) {
		var $qName = "ファシリテーション";
	} else if(Number(firstQttl[0]) == 2) {
		var $qName = "プレゼンテーション";
	} else if(Number(firstQttl[0]) == 3) {
		var $qName = "傾聴＆共感＆質問";
	} else if(Number(firstQttl[0]) == 4) {
		var $qName = "クロージング＆フォロー";
	} else if(Number(firstQttl[0]) == 5) {
		var $qName = "役割分担明確化";
	} else if(Number(firstQttl[0]) == 6) {
		var $qName = "見せるメモ";
	}
	var firstchildNum = 1 + parseInt(firstQttl[1]);
	$('#console').append('<p><b>'+$qName+'のスキルの問題 No.'+firstchildNum+'</b></p>');
	
});

//戻るボタン押下
$('button[name="back"]').on('click',function() {
	$('#'+$nextQ).delay(100).fadeOut('fast'); //終了した問題を消す
	question.back();	
	$('#'+$nextQ).delay(400).fadeIn('fast'); //次の問題を表示
	$('input').attr('disabled',false); //ダブルクリック防止解除
});

//ラジオボタンを押下
$('input[type="radio"]').on('click',function(){
	$(this).attr('disabled',true); //ダブルクリック防止
	//---nameから配列用番号を取得
	var temp = this.name.split('_');
	var ques_id = Number(temp[0]);
	var ans_id = Number(temp[1]);	
	answerArray[ques_id][ans_id] = parseInt($(this).val()); //---点数を配列に記憶
	$('#'+$nextQ).delay(100).fadeOut('fast');//終了した問題を消す
	question.next();
	var $num = $parentDiv.attr('data-current').replace(/[^0-9^\.]/g,'');
	if($num <= $totalQ) {
		$('#'+$nextQ).delay(100).fadeIn('fast');//次の問題を表示
		$('.progress-bar p').html($num + '問目 / 21問中');
		
		//テストツール用変数
		var nextQttl = $('#'+$nextQ+' input[type="radio"]').first().attr('name').split('_');
		
	} else {		
		$('#result').fadeIn('fast');//結果表示
		$('#diagnosis').addClass('result_open');
		result();
		
		//テストツール用変数
		var nextQttl = $(this).first().attr('name').split('_');		
	}
	
	//テストツール
	var childNum = 1 + parseInt(nextQttl[1]);
	if(Number(nextQttl[0]) == 0) {
		var $qName = "面談準備";
	} else if(Number(nextQttl[0]) == 1) {
		var $qName = "ファシリテーション";
	} else if(Number(nextQttl[0]) == 2) {
		var $qName = "プレゼンテーション";
	} else if(Number(nextQttl[0]) == 3) {
		var $qName = "傾聴＆共感＆質問";
	} else if(Number(nextQttl[0]) == 4) {
		var $qName = "クロージング＆フォロー";
	} else if(Number(nextQttl[0]) == 5) {
		var $qName = "役割分担明確化";
	} else if(Number(nextQttl[0]) == 6) {
		var $qName = "見せるメモ";
	}
	$('#console').empty();
	$('#console').html(JSON.stringify(answerArray));
	$('#console').append('<p>テストツール（inputのname参照。戻るボタン、最後の加算非対応）</p>');
	$('#console').append('<p><b>'+$qName+'のスキルの問題 No.'+childNum+'</b></p>');
	$('#console').append('<p>面談準備のスキルの合計：'+sum(answerArray[0]));
	$('#console').append('<p>ファシリテーションのスキルの合計：'+sum(answerArray[1]));
	$('#console').append('<p>プレゼンテーションスキルの合計：'+sum(answerArray[2]));
	$('#console').append('<p>傾聴＆共感＆質問のスキルの合計：'+sum(answerArray[3]));
	$('#console').append('<p>クロージング＆フォローのスキルの合計：'+sum(answerArray[4]));
	$('#console').append('<p>役割分担明確化のスキルの合計：'+sum(answerArray[5]));
	$('#console').append('<p>見せるメモのスキルの合計：'+sum(answerArray[6]));
	
});


});